import React, { useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import html2pdf from 'html2pdf.js';
import 'tinymce/tinymce';
import 'tinymce/models/dom/model';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';
import 'tinymce/skins/ui/oxide/skin';

// Plugins
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/autosave';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/code';
import 'tinymce/plugins/codesample';
import 'tinymce/plugins/directionality';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/help';
import 'tinymce/plugins/help/js/i18n/keynav/en';
import 'tinymce/plugins/image';
import 'tinymce/plugins/importcss';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/media';
import 'tinymce/plugins/nonbreaking';
import 'tinymce/plugins/pagebreak';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/quickbars';
import 'tinymce/plugins/save';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/table';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/visualchars';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/emoticons/js/emojis';

import 'tinymce/skins/content/default/content';
import 'tinymce/skins/ui/oxide/content';

const defaultTemplate = `
<h2>Einzelbuchungsvereinbarung für Zalando</h2>
<h4>Single Booking Agreement pursuant to General Booking Agreement for Zalando</h4>
<p>zwischen der ORENDT STUDIOS GmbH in Hamburg, Behringstrasse 28A, 22765 Hamburg nachstehend „Produzent“ genannt,</p>
<p>between ORENDT STUDIOS GmbH in Hamburg, Behringstrasse 28A, 22765 Hamburg, hereinafter referred to as „Producer“</p>
<p>und / and</p>
<p>Agentur [[Agency]] / Agency [[Agency]]</p>
<p>nachstehend "Agentur" genannt / hereinafter referred to as „Agency“</p>
<p>und / and</p>
<p>[[Model (Legal Name)]] vertreten durch die Agentur,</p>
<p>[[Model (Legal Name)]] represented by the Agency</p>
<p>nachstehend „Model“ genannt / hereinafter referred to as „Model“</p>
<ol>
<li>Für diesen Vertrag gelten die zwischen Agentur und Produzent vereinbarten Rahmenbedingungen. Diese sind Bestandteil dieses Vertrages.<br>The General Booking Conditions agreed upon between the Agency and the Producer shall become part of this Single Booking Agreement.</li>
<li>Buchungsdetails / Booking Details:</li>
</ol>
`;

export const TemplatePlaceholders = [
    { key: 'Model (Legal Name)' },
    { key: 'Agency' },
];

const modelSample = {
    'Model (Legal Name)': 'Jane Doe',
    Agency: 'Elite Models Munich',
};

function fillTemplate(template, data) {
    return template.replace(/\[\[(.*?)\]\]/g, (_, key) => data[key] || `[MISSING: ${key}]`);
}

export default function TemplateEditorTinyMCE() {
    const [template, setTemplate] = useState(defaultTemplate);
    const pdfRef = useRef();
    const editorRef = useRef();

    const handleInsertPlaceholder = (placeholder) => {
        const editor = editorRef.current;
        if (editor) {
            editor.insertContent(`[[${placeholder}]]`);
        }
    };

    const handleGenerate = () => {
        /*if (!editorRef.current) return;

        const styledHtml = editorRef.current.getContent({ format: 'html' });
        const filled = fillTemplate(styledHtml, modelSample);
        setFilledOutput(filled);*/
    };


    const embedTemplateStyles = async () => {

        try {
            const styledHtml = editorRef.current.getContent({ format: 'html' });
            const filled = fillTemplate(styledHtml, modelSample);
            const cssRes = await fetch('/booking-template.css');
            const cssText = await cssRes.text();

            const resultWithStyle = `
    <style>${cssText}</style>
    <div class="template-a4">
        ${filled}
    </div>
`;


            html2pdf().from(resultWithStyle).set({
                margin: [20, 10, 25, 10], // top, right, bottom, left (mm)
                filename: 'model_agreement.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
            }).save();
        } catch (err) {
            console.error('Failed to export PDF:', err);
            alert('Something went wrong while generating the PDF.');
        }
    };



    return (
        <div className="min-h-screen bg-gray-100 px-4 py-6 flex flex-col items-center" style={{ alignSelf: 'center' }}>
            <h1 className="text-2xl font-bold mb-4">PDF Template Editor</h1>

            <div className="flex flex-wrap gap-2 mb-2">
                {TemplatePlaceholders.map(({ key }) => (
                    <button
                        key={key}
                        onClick={() => handleInsertPlaceholder(key)}
                        className="button"
                    >
                        Insert [[{key}]]
                    </button>
                ))}

                <button
                    className="button"
                    onClick={embedTemplateStyles}
                >
                    Test Export as PDF
                </button>
            </div>

            <Editor
                tinymceScriptSrc='/tinymce/tinymce.min.js'
                onInit={(evt, editor) => editorRef.current = editor}
                value={template}
                onEditorChange={(content) => setTemplate(content)}
                init={{
                    base_url: '/tinymce',
                    suffix: '.min',
                    plugins: 'table code lists link',
                    toolbar: 'undo redo | bold italic | bullist numlist | table | code',
                    content_css: '/booking-template.css',
                    body_class: 'template-a4',
                    height: '100vh',
                    statusbar: false,
                    resize: false,
                }}
            />


            {/*<div className="flex gap-4 mt-4 mb-2">
                <button
                    className="bg-black text-white px-4 py-2 rounded hover:bg-gray-800"
                    onClick={handleGenerate}
                >
                    Fill Template
                </button>
            </div>*/}


            {/*<h2 className="text-xl font-semibold mb-2">Filled Output Preview</h2>
            <div
                ref={pdfRef}
                className="template-preview p-4 border border-gray-300 rounded bg-white"
            >
                <link rel="stylesheet" href="/booking-template.css" />
                <div className="template-a4" dangerouslySetInnerHTML={{ __html: filledOutput }} />
            </div>*/}
        </div>
    );
}
